<template>
  <div id="app">
    <router-view v-if="isRouterAlive" :key="approutekey"></router-view>
    <div class="goTop" @click="backTop" v-if="btnFlag">
      <i class="el-icon-caret-top"></i>
    </div>
    <!-- 蓝字补充弹框 -->
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="50%">
      <div>
        <div>您好，以下 发票号 存在补传发票或发生其他变动的情况，请及时进行处理：</div>
        <div>{{orderlist.join(",")}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="over" size="small">我已处理，不再提醒</el-button>
        <el-button type="primary" size="small" @click="dealInvoice">马上处理</el-button>
      </span>
    </el-dialog>

    <div class="freight-float-text" @click="dialogVisible2=true" v-if="userInfo&&userInfo.customerType==1">
      <!-- Element-UI 运费图标（左侧） -->
      <i class="el-icon-truck freight-icon"></i>
      <span class="freight-text">预估运费</span>
      <!-- 装饰性小三角（朝左） -->
      <span class="freight-triangle"></span>
    </div>

    <el-dialog title="预估运费" :visible.sync="dialogVisible2" width="600" top="10vh" :close-on-click-modal="false" custom-class="dialogVisible2" :before-close="beforeClose">
      <div class="dialogBox">
        <div class="cell">1. 下载Excel模版，填写商品SKU和数量 (
          <a class="excel" href="https://b2b.naturehike.cn/camp/profile/upload/预估物流费模板.xlsx" download>
            <i class="el-icon-document"></i>Excel模版</a>)</div>
        <div class="cell">2.
          <span style="color:#f56c6c;margin-right:3px;font-weight:bold">*</span>选择配送省份
          <el-select v-model="uploadParams.province" placeholder="请选择省份" filterable size="small" class="addrSelect">
            <el-option v-for="item in addrList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="cell">
          3. 上传填写好的Excel文件
          <el-upload class="upload-demo" ref="xlsxUpload" :show-file-list="false" name="file" :on-error="handleAvatarError" :before-upload="beforeAvatarUpload" :on-progress="handleAvatarProgress" :data="uploadParams" style="display:inline-block" :on-success="handleAvatarSuccess" :action="`${$baseUrl}/portal/nk/importWmsSkuFile`" accept=".xls,.xlsx" :multipl="false">
            <el-button size="small" type="primary">上传Excel</el-button>
          </el-upload>
        </div>
      </div>
      <div class="loadingBox" v-show="this.wmsObj.deliveryInfoList.length<1&&uploading">
        <i class="el-icon-loading"></i>
        <span class="info-text">正在计算中，请耐心等待...</span>
      </div>
      <div class="resultBox" v-show="this.wmsObj.deliveryInfoList.length>0">
        <div class="info-banner">计算结果</div>
        <div class="provinceWeight">
          <div>省份： {{wmsObj.province}}</div>
        </div>
        <el-table :data="wmsObj.deliveryInfoList" border size="small" style="width: 100%;margin-top:20px">
          <el-table-column prop="carrierName" label="物流公司">
          </el-table-column>
          <el-table-column prop="deliveryAmount" label="运费(元)">
          </el-table-column>
          <el-table-column prop="weight" label="重量(kg)">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="closeDialogVisible2">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  area_list,
  shoppingCartlist,
  copyRight,
  userImgList,
  alertInvoice,
  postClearRedNotice,
  clearInvoice
} from "@/api/xunyou";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      approutekey: "",
      backTop: this.backTop,
      postAlertInvoice: this.postAlertInvoice
    };
  },
  data() {
    return {
      uploading: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      isRouterAlive: true,
      btnFlag: false,
      dialogVisible: false,
      orderlist: [],
      dialogVisible2: false,
      uploadParams: {
        muid: JSON.parse(localStorage.getItem("userdata")).userId || "",
        userToken: JSON.parse(localStorage.getItem("userdata")).userToken || "",
        province: ""
      },
      wmsObj: {
        deliveryInfoList: [],
        province: ""
      },
      addrList: [
        {
          value: "北京市",
          label: "北京市"
        },
        {
          value: "天津市",
          label: "天津市"
        },
        {
          value: "上海市",
          label: "上海市"
        },
        {
          value: "重庆市",
          label: "重庆市"
        },
        {
          value: "河北省",
          label: "河北省"
        },
        {
          value: "山西省",
          label: "山西省"
        },
        {
          value: "辽宁省",
          label: "辽宁省"
        },
        {
          value: "吉林省",
          label: "吉林省"
        },
        {
          value: "黑龙江省",
          label: "黑龙江省"
        },
        {
          value: "江苏省",
          label: "江苏省"
        },
        {
          value: "浙江省",
          label: "浙江省"
        },
        {
          value: "安徽省",
          label: "安徽省"
        },
        {
          value: "福建省",
          label: "福建省"
        },
        {
          value: "江西省",
          label: "江西省"
        },
        {
          value: "山东省",
          label: "山东省"
        },
        {
          value: "河南省",
          label: "河南省"
        },
        {
          value: "湖北省",
          label: "湖北省"
        },
        {
          value: "湖南省",
          label: "湖南省"
        },
        {
          value: "广东省",
          label: "广东省"
        },
        {
          value: "海南省",
          label: "海南省"
        },
        {
          value: "四川省",
          label: "四川省"
        },
        {
          value: "贵州省",
          label: "贵州省"
        },
        {
          value: "云南省",
          label: "云南省"
        },
        {
          value: "陕西省",
          label: "陕西省"
        },
        {
          value: "甘肃省",
          label: "甘肃省"
        },
        {
          value: "青海省",
          label: "青海省"
        },
        {
          value: "台湾省",
          label: "台湾省"
        },
        {
          value: "内蒙古自治区",
          label: "内蒙古自治区"
        },
        {
          value: "广西壮族自治区",
          label: "广西壮族自治区"
        },
        {
          value: "西藏自治区",
          label: "西藏自治区"
        },
        {
          value: "宁夏回族自治区",
          label: "宁夏回族自治区"
        },
        {
          value: "新疆维吾尔自治区",
          label: "新疆维吾尔自治区"
        },
        {
          value: "香港特别行政区",
          label: "香港特别行政区"
        },
        {
          value: "澳门特别行政区",
          label: "澳门特别行政区"
        }
      ]
    };
  },
  created() {
    // console.log(11111);
    this.$store.dispatch("getNavList"); //获取导航栏列表
    this.$store.dispatch("getAreaList"); //省市区
    this.$store.dispatch("getCategoryList"); //全部商品分类
    if (this.userInfo.userToken) {
      this.postAlertInvoice();
      this.getshoppingCartlist(); // 默认代发
    }
    this.geTCopyright();
    this.getUserImg();
  },
  watch: {
    $route: {
      handler(to, from) {
        this.approutekey = (Math.random() * 10000).toFixed(6);
        this.userInfo=JSON.parse(localStorage.getItem("userdata")) || {};
      },
      immediate: true
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    closeDialogVisible2() {
      this.dialogVisible2 = false;
      this.initWmsObj();
    },
    beforeClose(done) {
      this.initWmsObj();
      done();
    },
    handleAvatarProgress() {
      this.uploading = true;
    },
    beforeAvatarUpload() {
      if (!this.uploadParams.province) {
        this.$message.error("请先选择配送省份");
        return false;
      }
      this.initWmsObj();
      return true;
    },
    initWmsObj() {
      // 初始
      this.uploading = false;
      this.wmsObj = {
        deliveryInfoList: [],
        province: ""
      };
    },
    handleAvatarError() {
      this.$message.error("上传失败！");
      this.initWmsObj();
      this.uploading = false;
      this.$refs.xlsxUpload.clearFiles();
    },
    handleAvatarSuccess(response, file, fileList) {
      // console.log(response);
      if (response.code == 0) {
        this.wmsObj.deliveryInfoList = response.data.deliveryInfoList;
        this.wmsObj.province = response.data.province;
      } else {
        this.$message.error(`${response.msg}`);
      }
      this.uploading = false;
    },
    over() {
      this.dialogVisible = false;
      clearInvoice({
        uid: this.userInfo.userId || "",
        userToken: this.userInfo.userToken || "",
        invoiceNumber: ""
      }).then(res => {
        console.log("不再提醒");
      });
    },
    dealInvoice() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$router.push("/invoiceList?tabs=2");
      }, 200);
    },
    postAlertInvoice() {
      let funUserdata = JSON.parse(localStorage.getItem("userdata")) || {};
      alertInvoice({
        userToken: funUserdata.userToken || "",
        uid: funUserdata.userId || ""
      })
        .then(res => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.orderlist = res.data;
              this.dialogVisible = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 80) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    backTop() {
      let scrollToptimer = setInterval(function() {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 3;
        document.documentElement.scrollTop -= speed;
        if (top < 15) {
          document.documentElement.scrollTop = 0;
          clearInterval(scrollToptimer);
        }
      }, 10);
    },
    // 获取版权名称
    geTCopyright() {
      copyRight()
        .then(res => {
          // console.log(res)
          if (res.code == 0) {
            this.informations = res.rows[0];
            this.setGlobleTitle(this.informations.name || "挪客商城");
            if (this.informations.powstatus == 1) {
              this.$router.push("/erroPage");
            } else {
              this.$store.commit("getcopyRight", this.informations);
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$message.error('查询失败,请稍后再试!')
        });
    },
    // 可刷新页面
    // reload(){
    //   this.isRouterAlive = false
    //   this.$nextTick(()=>{
    //     this.isRouterAlive = true
    //   })
    // },
    // 获取所有默认图片
    getUserImg() {
      userImgList().then(res => {
        if (res.code == 0) {
          this.$store.commit("getUserImg", res.rows[0]);
        }
      });
    },
    // 获取购物车
    getshoppingCartlist() {
      let agencyAddressFlag = false; //代发
      if (this.$store.state.shoppingCarNum == "2") {
        agencyAddressFlag = true;
      }
      shoppingCartlist({
        uid: this.userInfo.userId || "",
        userToken: this.userInfo.userToken || "",
        agencyAddressFlag: agencyAddressFlag
      })
        .then(res => {
          //  console.log(res,'购物车');
          if (res.code == "0") {
            this.$store.commit("getCartList", res.data);
          } else {
            if (res.code == "2001") {
              localStorage.clear();
              sessionStorage.clear();
              this.$router.replace("/login");
              this.$message({
                message: res.msg,
                type: "error",
                duration: 1500
              });
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
                duration: 2000
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$message.error('购物车查询失败，请稍后再试！')
        });
    }
  }
};
</script>

<style lang="less">
.addrSelect {
  .el-input__inner {
    background: #fff;
  }
}

.freight-float-text {
  position: fixed;
  right: 0; /* 贴紧右侧 */
  top: 30%; /* 垂直居中 */
  transform: translateY(-30%);
  /* 基础样式 */
  background: #409eff; /* Element-UI 主色调，保持统一 */
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 16px 10px 12px;
  border-radius: 8px 0 0 8px; /* 左侧圆角，右侧直角贴边 */
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 8px; /* 图标/文字/箭头间距 */
  transition: all 0.3s ease; /* 过渡动画 */
  /* hover 交互效果（提升体验） */
  .freight-float-text:hover {
    background: #66b1ff; /* Element-UI 主色调 hover 色 */
    padding-right: 20px; /* 轻微右移，增加动感 */
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }

  /* Element-UI 图标样式（左侧） */
  .freight-icon {
    font-size: 16px;
    flex-shrink: 0; /* 防止图标被压缩 */
  }

  /* 文字样式优化 */
  .freight-text {
    letter-spacing: 0.5px; /* 字间距，更易读 */
    white-space: nowrap; /* 防止文字换行 */
  }

  /* 装饰小三角（朝左） */
  .freight-triangle {
    display: inline-block;
    width: 0;
    height: 0;
    /* 箭头朝左 */
    border-width: 4px 6px 4px 0;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
    transition: transform 0.3s ease;
  }

  /* hover 时小三角位移 */
  .freight-float-text:hover .freight-triangle {
    transform: translateX(2px); /* 小三角轻微右移 */
  }

  /* 适配移动端 */
  @media (max-width: 768px) {
    .freight-float-text {
      padding: 8px 12px 8px 10px;
      font-size: 12px;
    }
    .freight-icon {
      font-size: 14px;
    }
  }
}

.dialogVisible2 {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .resultBox {
    margin-top: 12px;
    .info-banner {
      height: 42px;
      line-height: 42px;
      position: relative;
      background: #f9fafc;
      font-weight: bold;
      font-size: 16px;
      padding-left: 16px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        border-radius: 12px;
        height: 100%;
        background-color: #409eff;
      }
    }
    .provinceWeight {
      margin-top: 16px;
      display: flex;
      align-items: center;
    }
  }

  .dialogBox {
    background: #f9fafc;
    font-size: 14px;
    padding: 16px 12px;
    .cell {
      padding-top: 8px;
      .excel {
        color: #409eff;
      }
    }
  }

  .loadingBox {
    text-align: center;
    margin-top: 20px;
    background: #f9fafc;
    padding: 12px 16px;
  }
}

// --------------------
.mt-8 {
  margin-top: 8px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-6 {
  margin-right: 6px;
}
.goTop {
  position: fixed;
  right: 40px;
  bottom: 20%;
  background-color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #ff6700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
  &:hover {
    background: rgb(244, 244, 244);
  }
  .el-icon-caret-top {
    font-size: 24px;
  }
}

html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  word-break: break-all;
  padding: 0px;
  margin: 0px;
  min-width: 1200px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-popover.el-popper.backTopBox {
  top: auto !important;
  bottom: 10px;
}

.remarkPopover {
  z-index: 100 !important;
}

.bgfff {
  background: #fff;
}

.myScrollBar {
  max-height: 600px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
}

.preDialog {
  .el-dialog__body {
    padding: 0 20px 0 20px;
    .el-form-item {
      margin-bottom: 8px;
    }
  }
}

.usernameClass {
  min-width: 50px;
  max-width: 300px;
}

.tabPopover {
  max-width: 300px;
}

.nkColor {
  background: #ff6700 !important;
  border-color: #ff6700 !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.nkF56C6C {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.nkTheamColor {
  background: #ea0a2a !important;
  border-color: #ea0a2a !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.scienceColor {
  background: #394af8 !important;
  border-color: #394af8 !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.overflowHiden {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.overflowEllipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.plr-10 {
  padding-right: 10px;
  padding-left: 10px;
}

img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue